<template>
    <section id="knowledge-base-search">
        <div class="row">
            <div class="col-12">
                <div class="card knowledge-base-bg text-center" style="background: #4b9a5e !important;">
                    <div class="card-body" style="padding: 3rem !important;">
                        <h2 style="color:white;" v-if="searchTitle">{{searchTitle}}</h2>
                        <h2 style="color:white;" v-else>Knowledge Center </h2>
                        <p class="card-text mb-2" style="color:white;">
                            <span>Popular searches: </span><span class="font-weight-bolder">Disputes Center, Letter
                                Tracking , Credit Report </span>
                        </p>

                        <form class="kb-search-input" v-on:submit.prevent="searchCartegory($e)">
                            <div class="input-group input-group-merge">
                                <div class="input-group-prepend">
                                    <span class="input-group-text"><i data-feather="search"></i></span>
                                </div>
                                <input type="text" class="form-control" id="searchbar"
                                    placeholder="Type your question..." v-model="searchitem"
                                    @keyup="searchCartegory($e)" />
                            </div>
                        </form>

                    </div>
                </div>
            </div>
        </div>
    </section>
</template>
<script>
import axios from 'axios';
import { ref, reactive, computed, toRefs } from 'vue'

export default {
    name: 'KnowledgeBaseSearch',
    components: {

    },
    props: {
        searchTitle: {
            type: String,
        },
        url: {
            type: String,
        },
        method: {
            type: Function,
        },
        pagination: {
            type: Boolean
        }
    },
    setup(props) {
        const state = reactive({
            result: {},
            searchitem: ref(null),
        }),
            pathUrl = computed(() => {
                return props.url
            }),
            searchResults = computed(() => {
                return props.method
            }),
            stoppedTyping = ref(),
            pagination = computed(() => {
                return props.pagination
            });
        return {
            searchResults,
            pathUrl,
            stoppedTyping,
            pagination,
            ...toRefs(state),
        }
    },
    methods: {
        searchCartegory(e) {
            if (this.searchitem != "") {
                var param = {
                    searchTerm: this.searchitem
                }
                clearTimeout(this.stoppedTyping)
                this.stoppedTyping = setTimeout(x => {
                    axios.post(`${this.pathUrl}`, param).then(({ data }) => {
                        return this.searchResults(data, false);
                    }).catch((error) => {
                        toastr.error(error, 'Error!');
                    })
                }, 1000)
            }else{
                let data = [{}]
                return this.searchResults(data, true);
            }


        }
    },
};
</script>
